import { Typography } from 'antd'

interface BeianFooterProps {
  style?: React.CSSProperties
}

function BeianFooter({ style }: BeianFooterProps) {
  return (
    <div
      style={{
        textAlign: 'center',
        color: 'rgba(0, 0, 0, 0.45)',
        fontSize: 12,
        padding: '12px 16px 8px',
        ...style,
      }}
    >
      <Typography.Link href="https://beian.miit.gov.cn/" target="_blank" rel="noreferrer">
        沪ICP备2026017055号-1
      </Typography.Link>
    </div>
  )
}

export default BeianFooter